module.exports = __webpack_public_path__ + "static/media/banner.1888cd08.png";